import GA4React from 'ga-4-react';
import { env } from '../utils/env/config';

export const setGoogleAnalytics = async () => {
  const { analytic } = env;
  if (!analytic) {
    console.log(`##### PLEASE CONFIG GOOGLE ANALYTICS ####`);
    return;
  }

  try {
    const ga4react = new GA4React(`${analytic}`);
    let ga4;
    if (!GA4React.isInitialized()) {
      ga4 = await ga4react.initialize();
    } else {
      ga4 = GA4React.getGA4React();
    }

    // ✅ เพิ่มส่วนนี้ให้แน่ใจว่า return object มี event และ pageView ใช้งานได้แน่
    return {
      pageView: (pathname, routeName, title) => {
        if (ga4 && typeof ga4.pageview === 'function') {
          ga4.pageview(pathname, routeName, title);
        } else {
          console.warn('GA pageview not available');
        }
      },
      event: (eventName, params) => {
        if (ga4 && typeof ga4.event === 'function') {
          ga4.event(eventName, params);
        } else if (ga4react && typeof ga4react.event === 'function') {
          // fallback ให้ยิงผ่าน ga4react โดยตรง
          ga4react.event(eventName, params);
        } else {
          console.warn('GA event not available');
        }
      }
    };
  } catch (error) {
    console.error('GA init error:', error);
    return null;
  }
};
